import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CountryAbbreviationEnum } from 'src/app/shared/enum/country-abbreviation.enum';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private _httpClient: HttpClient) { }

  private _locationApiUrl = environment.runtime.locationApiUrl;

  public search(query: string, countryCode: string, endPoint: string = '/experian/search') {
    query = query.trim();
    return this._httpClient.get(`${this._locationApiUrl}${endPoint}?query=${query}&country=${countryCode}`);
  }

  public format(address: string, country: string, endPoint: string = '/experian/format') {
    return this._httpClient.post(`${this._locationApiUrl}${endPoint}`, { id: address, country: country }).toPromise();
  }

  public verify(location: string, country: string, endPoint: string = '/search/address') {
    return this._httpClient.post(`${this._locationApiUrl}${endPoint}`, {'location': location, 'country': country});
  }

  public parseAddress(experianResponse: any): any {
    return {
      Address1: experianResponse['address'][0]['addressLine1'],
      Address2: experianResponse['address'][1]['addressLine2'],
      City: experianResponse['address'][3]['locality'],
      State: experianResponse['address'][4]['province'],
      PostalCode: experianResponse['address'][5]['postalCode'].split("-")[0],
      CountryCode: this._findCountryCode(experianResponse['components']),
    }
  }

  public formatAddress(address: any): string {
    if (!address.street || !address.city || !address.state || !address.country) return '';

    switch(address.country) {
      case CountryAbbreviationEnum.USA:
        return `${address.street}, ${address.city} ${address.state} ${address.postalCode}`;

      case CountryAbbreviationEnum.MEXICO:
        return `${address.street}, ${address.postalCode} ${address.city}, ${address.state}`;

      case CountryAbbreviationEnum.CANADA:
        return `${address.street}, ${address.city}, ${address.state}, ${address.postalCode}`;

      default:
        return '';
    }
  }

  private _findCountryCode(components: any[]) {
    let countryCode = '';

    components.forEach(com => {
      if(com['countryISO1']) countryCode = com['countryISO1'];
    });

    return countryCode;
  }
}
